import React, { Component } from 'react';

import Page from '../components/Page';
import StepsNavigation from '../components/StepsNavigation';
import Shipment from '../pages/buy/Shipment';
import SupportingDocuments from '../pages/buy/BuyerDetails';
import Payment from '../pages/buy/Payment';
import GetCertificate from '../pages/buy/GetCertificate';

import { translations } from '../i18n/translations';

export default class BuyInsurance extends Component{

    getPageDetails(){
        const { shipment_details, payment, print_certificate, supporting_documents } = translations;

        var section = {}
        
        switch(this.props.match.params.id){

            case "buyer-details":
                section = {
                    title: supporting_documents,
                    content: <SupportingDocuments />
                }
                break
            
            case "payment":
                section = {
                    title: payment,
                    content: <Payment />
                }
                break

            case "get-certificate":
                section = {
                    title: print_certificate,
                    content: <GetCertificate />
                }
                break
            
            default:
                section = {
                    title: shipment_details,
                    content: <Shipment />
                }
                break
        }

        return section;
    }

    render(){
        var { title, content } = this.getPageDetails()

    	return(
    		<Page pageTitle={ title } noPageHeader={ true }>
                <div className="card clearfix">
                    <StepsNavigation />
                    { content }
                    </div>
            </Page>
    	);
    }
}


// WEBPACK FOOTER //
// ./src/pages/BuyInsurance.jsx